// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__bu01I {
  min-height: 100vh;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 1.5rem;
  border-top: 1px solid #8080801a; }

.styles_featuresSection__FBWBC {
  width: 100%; }

.styles_contentWrapper__GucOg {
  max-width: 72rem;
  margin: 0 auto; }

.styles_headerSection__yNHBV {
  text-align: center;
  margin-bottom: 5rem; }

.styles_sectionTitle__jw6Ej {
  font-size: 1.875rem;
  font-weight: 300;
  color: #808080e6;
  margin-bottom: 1.5rem;
  text-align: left; }
  @media (min-width: 48rem) {
    .styles_sectionTitle__jw6Ej {
      font-size: 2.5rem; } }

.styles_decorativeDivider__ia17t {
  width: 6rem;
  height: 0.125rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  border-radius: 0.0625rem; }

.styles_featuresGrid__oMYAS {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem; }
  @media (min-width: 48rem) {
    .styles_featuresGrid__oMYAS {
      grid-template-columns: repeat(2, 1fr); } }
  @media (min-width: 64rem) {
    .styles_featuresGrid__oMYAS {
      grid-template-columns: repeat(3, 1fr); } }

.styles_featureCard__Cx3KO {
  background: #80808008;
  backdrop-filter: blur(0.5rem);
  border-radius: 1.5rem;
  padding: 1rem 2rem;
  border: 1px solid #8080801a;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  transition: all 0.5s ease;
  cursor: pointer; }
  .styles_featureCard__Cx3KO:hover {
    box-shadow: 0 0.5 rem 1rem rgba(0, 0, 0, 0.1);
    transform: scale(1.1);
    background: rgba(99, 102, 241, 0.05); }
    .styles_featureCard__Cx3KO:hover .styles_iconContainer__x2e2O {
      transform: scale(1.1); }
    .styles_featureCard__Cx3KO:hover .styles_cardDetails__-n-z9 {
      opacity: 1; }
    .styles_featureCard__Cx3KO:hover .styles_cardDescription__zbwnn {
      color: #808080e6; }

.styles_iconContainer__x2e2O {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  transition: transform 0.3s ease; }
  .styles_iconContainer__x2e2O svg {
    width: 1.5rem;
    height: 1.5rem;
    color: white; }

.styles_from-spiritual-blue-to-spiritual-purple__is8fc {
  background: linear-gradient(135deg, #6366f1, #dc2626, #8b5cf6); }

.styles_from-spiritual-crimson-to-spiritual-purple__CQlFu {
  background: linear-gradient(135deg, #dc2626, #8b5cf6); }

.styles_from-spiritual-crimson-to-spiritual-blue__pRSxm {
  background: linear-gradient(135deg, #dc2626, #6366f1); }

.styles_from-spiritual-blue-to-spiritual-crimson__x5i9D {
  background: linear-gradient(135deg, #6366f1, #dc2626); }

.styles_cardTitle__BhO9O {
  font-size: 1.25rem;
  font-weight: 500;
  color: #808080e6;
  margin-bottom: 1rem; }

.styles_cardDescription__zbwnn {
  font-size: 1.25rem;
  color: #808080b8;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease, font-size 0.3s ease; }

.styles_cardDetails__-n-z9 {
  opacity: 0;
  transition: opacity 0.3s ease; }

.styles_detailsText__xUm\\+x {
  font-size: 0.875rem;
  color: #80808080;
  line-height: 1.5;
  font-style: italic; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/FeaturesSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BCEgB,EAAA;;ADClB;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBCZgB;EDahB,qBAAqB;EACrB,gBAAgB,EAAA;EAEhB;IAPF;MAQI,iBAAiB,EAAA,EAEpB;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAC7D,wBAAwB,EAAA;;AAG1B;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS,EAAA;EAET;IALF;MAMI,qCAAqC,EAAA,EAMxC;EAHC;IATF;MAUI,qCAAqC,EAAA,EAExC;;AAED;EACE,qBCpDc;EDqDd,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,2BCrDgB;EDsDhB,gDAAgD;EAChD,yBAAyB;EACzB,eAAe,EAAA;EARjB;IAWI,6CAA6C;IAC7C,qBAAqB;IACrB,oCAAoC,EAAA;IAbxC;MAgBM,qBAAqB,EAAA;IAhB3B;MAoBM,UAAU,EAAA;IApBhB;MAwBM,gBClEY,EAAA;;ADuElB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B,EAAA;EARjC;IAWI,aAAa;IACb,cAAc;IACd,YAAY,EAAA;;AAOhB;EACE,8DAA8D,EAAA;;AAGhE;EACE,qDAAqD,EAAA;;AAGvD;EACE,qDAAqD,EAAA;;AAGvD;EACE,qDAAqD,EAAA;;AAGvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBC9GgB;ED+GhB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,gBCrHgB;EDsHhB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C,EAAA;;AAGhD;EACE,UAAU;EACV,6BAA6B,EAAA;;AAI/B;EACE,mBAAmB;EACnB,gBCrIgB;EDsIhB,gBAAgB;EAChB,kBAAkB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  min-height: 100vh;\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8rem 1.5rem;\n  border-top: 1px solid $grey10;\n}\n\n.featuresSection {\n  width: 100%;\n}\n\n.contentWrapper {\n  max-width: 72rem;\n  margin: 0 auto;\n}\n\n.headerSection {\n  text-align: center;\n  margin-bottom: 5rem;\n}\n\n.sectionTitle {\n  font-size: 1.875rem;\n  font-weight: 300;\n  color: $grey90;\n  margin-bottom: 1.5rem;\n  text-align: left;\n\n  @media (min-width: 48rem) {\n    font-size: 2.5rem;\n  }\n}\n\n.decorativeDivider {\n  width: 6rem;\n  height: 0.125rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  border-radius: 0.0625rem;\n}\n\n.featuresGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 2rem;\n\n  @media (min-width: 48rem) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @media (min-width: 64rem) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.featureCard {\n  background: $grey3;\n  backdrop-filter: blur(0.5rem);\n  border-radius: 1.5rem;\n  padding: 1rem 2rem;\n  border: 1px solid $grey10;\n  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  transition: all 0.5s ease;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0 0.5 rem 1rem rgba(0, 0, 0, 0.1);\n    transform: scale(1.1);\n    background: rgba(99, 102, 241, 0.05);\n\n    .iconContainer {\n      transform: scale(1.1);\n    }\n\n    .cardDetails {\n      opacity: 1;\n    }\n\n    .cardDescription {\n      color: $grey90;\n    }\n  }\n}\n\n.iconContainer {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n  transition: transform 0.3s ease;\n\n  & svg {\n    width: 1.5rem;\n    height: 1.5rem;\n    color: white;\n  }\n}\n\n.cardIcon {}\n\n// Gradient classes for icon containers - using kebab-case for class names\n.from-spiritual-blue-to-spiritual-purple {\n  background: linear-gradient(135deg, #6366f1, #dc2626, #8b5cf6);\n}\n\n.from-spiritual-crimson-to-spiritual-purple {\n  background: linear-gradient(135deg, #dc2626, #8b5cf6);\n}\n\n.from-spiritual-crimson-to-spiritual-blue {\n  background: linear-gradient(135deg, #dc2626, #6366f1);\n}\n\n.from-spiritual-blue-to-spiritual-crimson {\n  background: linear-gradient(135deg, #6366f1, #dc2626);\n}\n\n.cardTitle {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: $grey90;\n  margin-bottom: 1rem;\n}\n\n.cardDescription {\n  font-size: 1.25rem;\n  color: $grey72;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  transition: all 0.3s ease, font-size 0.3s ease;\n}\n\n.cardDetails {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n\n}\n\n.detailsText {\n  font-size: 0.875rem;\n  color: $grey50;\n  line-height: 1.5;\n  font-style: italic;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__bu01I`,
	"featuresSection": `styles_featuresSection__FBWBC`,
	"contentWrapper": `styles_contentWrapper__GucOg`,
	"headerSection": `styles_headerSection__yNHBV`,
	"sectionTitle": `styles_sectionTitle__jw6Ej`,
	"decorativeDivider": `styles_decorativeDivider__ia17t`,
	"featuresGrid": `styles_featuresGrid__oMYAS`,
	"featureCard": `styles_featureCard__Cx3KO`,
	"iconContainer": `styles_iconContainer__x2e2O`,
	"cardDetails": `styles_cardDetails__-n-z9`,
	"cardDescription": `styles_cardDescription__zbwnn`,
	"from-spiritual-blue-to-spiritual-purple": `styles_from-spiritual-blue-to-spiritual-purple__is8fc`,
	"from-spiritual-crimson-to-spiritual-purple": `styles_from-spiritual-crimson-to-spiritual-purple__CQlFu`,
	"from-spiritual-crimson-to-spiritual-blue": `styles_from-spiritual-crimson-to-spiritual-blue__pRSxm`,
	"from-spiritual-blue-to-spiritual-crimson": `styles_from-spiritual-blue-to-spiritual-crimson__x5i9D`,
	"cardTitle": `styles_cardTitle__BhO9O`,
	"detailsText": `styles_detailsText__xUm+x`
};
export default ___CSS_LOADER_EXPORT___;
